<template>
  <!-- eslint-disable max-len -->
  <div class="container">
    <script type="application/javascript" defer :src="'https://www.paypal.com/sdk/js?client-id='+paypal_client_id+'&currency=EUR'" async data-csp-nonce="xyz-123"></script>
    <Loading :active.sync="processing" :can-cancel="false" />

    <div class="columns is-centered is-multiline">
      <div v-if="isAvailable('paypal_credit')" class="column is-3">
        <h5
          class="title cursor-is-pointer"
          @click.prevent="setPaymentMethod('paypal_credit')"
          v-text="$t('cart.credit-card-title')"
        />
        <a
          :class="payment_method == 'paypal_credit' ? 'active' : ''"
          class="payment-method"
          title="Credit card"
          href="#pay-with-paypal-credit"
          @click.prevent="setPaymentMethod('paypal_credit')"
        >
          <img src="/images/payment-methods/credit-card-paypal.png" />
        </a>
      </div>
      <div v-if="isAvailable('mangopay')" class="column is-3">
        <h5
          class="title cursor-is-pointer"
          @click="setPaymentMethod('mangopay')"
          v-text="$t('cart.credit-card-title')"
        />
        <a
          :class="payment_method == 'mangopay' ? 'active' : ''"
          class="payment-method"
          title="Credit card"
          href="#credit-card-information"
          @click="setPaymentMethod('mangopay')"
        >
          <img src="/images/payment-methods/credit-card-mango-pay.png" />
        </a>
      </div>
      <div v-if="isAvailable('paypal')" class="column is-3">
        <h5
          class="title cursor-is-pointer"
          @click.prevent="setPaymentMethod('paypal')"
          v-text="$t('cart.paypal-title')"
        />
        <a
          :class="payment_method == 'paypal' ? 'active' : ''"
          class="payment-method"
          title="PayPal"
          href="#pay-with-paypal"
          @click.prevent="setPaymentMethod('paypal')"
        >
          <img src="/images/payment-methods/paypal.png" />
        </a>
      </div>
      <div v-if="isAvailable('bankwire')" class="column is-3">
        <h5
          class="title cursor-is-pointer"
          @click.prevent="setPaymentMethod('bankwire')"
          v-text="$t('cart.bank-wire-title')"
        />
        <a
          :class="payment_method == 'bankwire' ? 'active' : ''"
          class="payment-method"
          title="Bank Transfer"
          href="#pay-with-bank-wire"
          @click.prevent="setPaymentMethod('bankwire')"
        >
          <img src="/images/payment-methods/bank-transfer.png" />
        </a>
      </div>
      <div v-if="isAvailable('wallet') && parseFloat(wallet_balance)" class="column is-3">
        <h5
          class="title cursor-is-pointer"
          @click.prevent="setPaymentMethod('wallet')"
          v-text="$t('cart.wallet-title')+ ' ('+wallet_balance+' EUR)'"
        />
        <a
          :class="payment_method == 'wallet' ? 'active' : ''"
          class="payment-method"
          title="Wallet"
          href="#pay-with-wallet"
          @click.prevent="setPaymentMethod('wallet')"
        >
          <img src="/images/payment-methods/wallet.svg" />
        </a>
      </div>
    </div>

    <div
      v-show="payment_method == 'mangopay'"
      id="credit-card-information"
      class="mt-3"
    >
      <div class="columns is-centered">
        <div class="column is-three-fifths is-12-touch">
          <form
            :action="credit_card_pay_route"
            class=""
            role="form"
            method="POST"
          >
            <div class="credit-card-information">
              <h4 class="title" v-text="$t('cart.your-credit-card-details')" />
              <div class="separator" />
              <div class="columns">
                <div class="column">
                  <div class="field has-addons">
                    <p class="control">
                      <a class="button is-static is-medium">
                        <i class="fa fa-credit-card" />
                      </a>
                    </p>
                    <p class="control is-expanded">
                      <input
                        id="number"
                        v-model="creditCardForm.number"
                        :placeholder="$t('cart.credit-card-number')"
                        :class="
                          creditCardForm.errors.has('number') ? 'is-danger' : ''
                        "
                        class="input is-medium"
                        type="text"
                        name="number"
                      />
                    </p>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column is-6">
                  <div class="field has-addons">
                    <p class="control">
                      <a class="button is-static is-medium">
                        <i class="fa fa-calendar" />
                      </a>
                    </p>
                    <p class="control">
                      <input
                        id="expiration_month"
                        v-model="creditCardForm.expiration_month"
                        :placeholder="$t('cart.credit-card-expiration-month')"
                        :class="
                          creditCardForm.errors.has('expiration_month')
                            ? 'is-danger'
                            : ''
                        "
                        class="input is-medium has-text-centered"
                        type="text"
                        name="expiration_month"
                      />
                    </p>

                    <p class="control">
                      <a class="button is-static is-medium">
                        /
                      </a>
                    </p>

                    <p class="control">
                      <input
                        id="expiration_year"
                        v-model="creditCardForm.expiration_year"
                        :placeholder="$t('cart.credit-card-expiration-year')"
                        :class="
                          creditCardForm.errors.has('expiration_year')
                            ? 'is-danger'
                            : ''
                        "
                        class="input is-medium has-text-centered"
                        type="text"
                        name="expiration_year"
                      />
                    </p>
                  </div>
                </div>

                <div class="column is-6">
                  <div class="field has-addons">
                    <p class="control">
                      <a class="button is-static is-medium">
                        <i class="fa fa-lock" />
                      </a>
                    </p>
                    <p class="control is-expanded">
                      <input
                        id="cvc"
                        v-model="creditCardForm.cvc"
                        :class="
                          creditCardForm.errors.has('cvc') ? 'is-danger' : ''
                        "
                        :placeholder="$t('cart.credit-card-cvc')"
                        class="input is-medium"
                        type="text"
                        name="cvc"
                      />
                    </p>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <button
                      :disabled="processing"
                      class="button is-primary is-medium is-outlined is-fullwidth"
                      @click.prevent="payWithCreditCard()"
                      v-text="`${$t('cart.pay-button-credit-card')} €${price}`"
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div v-show="payment_method == 'paypal'" id="pay-with-paypal" class="mt-3">
      <div class="columns is-centered">
        <div class="column is-half is-full-touch">
          <div class="field">
            <form :action="paypal_pay_route" role="form" method="POST">
              <div class="credit-card-information">
                <h4 class="title" v-text="$t('cart.pay-with-paypal')" />

                <div class="separator" />

                <button
                  :disabled="processing"
                  class="button is-primary is-medium is-outlined is-fullwidth"
                  @click.prevent="payWithPaypal()"
                  v-html="`${$t('cart.pay-button-paypal')} €${price}`"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div v-show="payment_method == 'paypal_credit'" id="pay-with-paypal-credit" class="mt-3">
      <div class="columns is-centered">
        <div class="column is-half is-full-touch">
          <div class="field">
            <div class="credit-card-information">
              <h4 class="title" v-text="$t('cart.credit-card-title')" />
              <div class="separator" />
              <div class="title" style="font-size: 1.25rem;"><b>{{`${$t('cart.pay-button-paypal-credit')} €${price}`}}</b></div>
              <div id="paypal-button-container"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-show="payment_method == 'bankwire'"
      id="pay-with-bank-wire"
      class="mt-3"
    >
      <div class="columns is-centered">
        <div class="column is-half is-full-touch">
          <div class="field">
            <form :action="bank_wire_pay_route" role="form" method="POST">
              <div class="credit-card-information">
                <h4 class="title" v-text="$t('cart.pay-with-bank-wire')" />

                <div class="separator" />

                <button
                  :disabled="processing"
                  class="button is-primary is-medium is-outlined is-fullwidth"
                  @click.prevent="payWithBankWire()"
                  v-html="`${$t('cart.pay-button-bank-wire')} €${price}`"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div
      v-show="payment_method == 'wallet'"
      id="pay-with-wallet"
      class="mt-3"
    >
      <div class="columns is-centered">
        <div class="column is-half is-full-touch">
          <div class="field">
            <form :action="wallet_pay_route" role="form" method="POST">
              <div class="credit-card-information">
                <h4 class="title" v-text="$t('cart.pay-with-wallet')" />

                <div class="separator" />

                <button
                  :disabled="processing"
                  class="button is-primary is-medium is-outlined is-fullwidth"
                  @click.prevent="payWithWallet()"
                  v-html="`${$t('cart.pay-button')} €${price}`"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Form from '../../helpers/Form/Form';

export default {
  name: 'Payment',

  props: {
    price: { required: true, type: Number },
    credit_card_pay_route: { required: true, type: String },
    paypal_pay_route: { required: true, type: String },
    bank_wire_pay_route: { required: true, type: String },
    wallet_pay_route: { required: true, type: String },
    available_methods: { required: true, type: Array },
    wallet_balance: { required: true, type: String },
    paypal_client_id: { type: String, default: '' }
  },

  data() {
    return {
      processing: false,
      payment_method: 'mangopay',
      creditCardForm: new Form({
        number: null,
        expiration_month: null,
        expiration_year: null,
        cvc: null
      }),
      paypalForm: new Form({}),
      bankWireForm: new Form({}),
      is_paypal_button_loaded: false
    };
  },

  created() {
    if (!this.isAvailable(this.payment_method)) {
      this.payment_method = this.available_methods[0];
    }
  },

  mounted() {
    //load paypal buttons
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        this.loadPayPalButton();
      }
    };
  },

  methods: {
    isAvailable(payment) {
      return this.available_methods.indexOf(payment) !== -1;
    },

    setPaymentMethod(method) {
      this.payment_method = method;
      VueEventHub.$emit('add-payment-info', method, this.$store.getters.cartProducts, this.$store.getters.totals);
    },

    payWithCreditCard() {
      this.processing = true;

      this.creditCardForm
        .post(this.credit_card_pay_route)
        .then(response => {
          if (response.security_url) {
            location.href = response.security_url;
          }

          if (response.success && response.processed) {
            location.href = `
              /payment-gateway/mango-pay-callback/${response.cart_id}
              ?transactionId=${response.transaction_id}
            `;
          }

          this.processing = false;
        })
        .catch(err => {
          this.processing = false;
          const msg =
            err.data && err.data.message
              ? err.data.message
              : this.$t('cart.credit-cart-flash-error');

          error(msg);

          Swal.fire('Oops...', `Something went wrong! <br/> ${msg}`, 'error');

          this.processing = false;
        });
    },

    payWithPaypal() {
      this.processing = true;

      this.paypalForm
        .post(this.paypal_pay_route)
        .then(response => {
          location.href = response.redirect_url;
        })
        .catch(err => {
          this.processing = false;
          const msg =
            err.data && err.data.message
              ? err.data.message
              : this.$t('cart.credit-cart-flash-error');

          error(msg);

          Swal.fire('Oops...', `Something went wrong! <br/> ${msg}`, 'error');
        });
    },

    payWithBankWire() {
      this.processing = true;

      this.paypalForm
        .post(this.bank_wire_pay_route)
        .then(response => {
          location.href = response.redirect_url;
        })
        .catch(err => {
          this.processing = false;
          const msg =
            err.data && err.data.message
              ? err.data.message
              : this.$t('cart.credit-cart-flash-error');

          error(msg);

          Swal.fire('Oops...', `Something went wrong! <br/> ${msg}`, 'error');
        });
    },

    payWithWallet() {
      this.processing = true;

      this.paypalForm
        .post(this.wallet_pay_route)
        .then(response => {
          location.href = response.redirect_url;
        })
        .catch(err => {
          this.processing = false;
          const msg =
            err.data && err.data.message
              ? err.data.message
              : this.$t('cart.credit-cart-flash-error');

          error(msg);

          Swal.fire('Oops...', `${msg}`, 'error');
        });
    },

    loadPayPalButton() {
      if (!this.is_paypal_button_loaded) {
        this.is_paypal_button_loaded = true;
        const $this = this;
        /* eslint-disable no-undef */
        paypal.Buttons({
          fundingSource: paypal.FUNDING.CARD,
          createOrder: () => {
            $this.processing = true;
            return fetch('/pay-pal-payment-gateway/create-order', {
              headers: {
                'X-CSRF-Token': document.head.querySelector('[name~=csrf-token][content]').content,
                'Content-Type': 'application/json'
              },
              method: 'post'
            }).then(function (response) {
              $this.processing = false;
              return response.json();
            }).then(function (order_data) {
              return order_data.result.id;
            });
          },
          onApprove: (data, actions) => {
            $this.processing = true;
            return fetch('/pay-pal-payment-gateway/capture-payment/' + data.orderID, {
              headers: {
                'X-CSRF-Token': document.head.querySelector('[name~=csrf-token][content]').content,
                'Content-Type': 'application/json'
              },
              method: 'post'
            }).then(function (res) {
              $this.processing = false;
              return res.json();
            }).then(function (order_data, actions) {
              // Three cases to handle:
              //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
              //   (2) Other non-recoverable errors -> Show a failure message
              //   (3) Successful transaction -> Show confirmation or thank you

              const error_detail = Array.isArray(order_data.result.details) && order_data.result.details[0];
              if (error_detail && error_detail.issue === 'INSTRUMENT_DECLINED') {
                return actions.restart();
              }

              if (error_detail) {
                let msg = 'Sorry, your transaction could not be processed.';
                if (error_detail.description) msg += '\n\n' + error_detail.description;
                Swal.fire('Oops...', `Something went wrong! <br/> ${msg}`, 'error');
              }
              if (order_data && order_data.result) {
                location.href = order_data.result.success_redirect_url;
              }
            });
          },
          onError: function () {
            $this.processing = false;
            Swal.fire('Oops...', 'Something went wrong!', 'error');
          }
        }).render('#paypal-button-container');
        /* eslint-enable no-undef */
      }
    }
  }
};
</script>
